import { render } from "./CouponOptions.vue?vue&type=template&id=8c8e3a4e&scoped=true&ts=true"
import script from "./CouponOptions.vue?vue&type=script&lang=ts"
export * from "./CouponOptions.vue?vue&type=script&lang=ts"

import "./CouponOptions.vue?vue&type=style&index=0&id=8c8e3a4e&scoped=true&lang=scss"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8e3a4e"]])

export default __exports__